module.exports = require('../../es/promise');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/stable/promise/index.js
// module id = 715
// module chunks = 0 1 2